import { render, staticRenderFns } from "./SupportingDocumnets.vue?vue&type=template&id=59a98b88&scoped=true&"
import script from "./SupportingDocumnets.vue?vue&type=script&lang=js&"
export * from "./SupportingDocumnets.vue?vue&type=script&lang=js&"
import style0 from "./SupportingDocumnets.vue?vue&type=style&index=0&id=59a98b88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a98b88",
  null
  
)

export default component.exports